import React, { useState, useEffect, useRef } from "react";
import { Container } from "react-bootstrap";
import "./Second.css";
import loader from "../../../Asset/new-loader.svg";
import InfiniteScroll from "react-infinite-scroll-component";
import { useNavigate, useSearchParams } from "react-router-dom";
import portfolioData from "../../../portfolio";

const Second = () => {
  const [isActiveIndustry, setIsActiveIndustry] = useState(false);
  const [isActiveTechnology, setIsActiveTechnology] = useState(false);
  const [selectedIndustry, setSelectedIndustry] = useState("All Industries");
  const [selectedTechnology, setSelectedTechnology] =
    useState("All Technologies");
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const [filteredItems, setFilteredItems] = useState([]);
  const [displayedItems, setDisplayedItems] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false); // For infinite scroll
  const [filtering, setFiltering] = useState(false); // For filtering loader
  const itemsPerPage = 6;

  const truncateText = (text, limit = 70) =>
    text?.length > limit ? text.slice(0, limit) + "..." : text;

  const industryRef = useRef(null);
  const technologyRef = useRef(null);

  const industries = [
    "All Industries",
    "AI & IoT",
    "Customer Support",
    "D2C",
    "E-Commerce",
    "Education",
    "Entertainment",
    "Fintech",
    "Fitness",
    "Health",
    "Investment",
    "Logistics & Shipping",
    "Process Management",
    "Others",
  ];

  const technologies = [
    "All Technologies",
    "Angular",
    "Java",
    "Node",
    "React",
    "React Native",
    "Shopify",
    "WordPress",
  ];

  const normalizeTechnology = (value) => {
    if (!value) return "";
    const normalized = value.toLowerCase().replace(/[^a-z0-9]/g, "");

    if (normalized === "reactjs") return "react";
    if (normalized === "nodejs") return "node";

    return normalized;
  };

  const resolveTechnologyFromQuery = (value) => {
    if (!value) return "All Technologies";
    const normalized = normalizeTechnology(value);
    const match = technologies.find(
      (tech) => normalizeTechnology(tech) === normalized,
    );

    return match || "All Technologies";
  };

  const resolveTechnologyFromParams = (params) => {
    const paramKeys = Array.from(params.keys());
    const match = technologies.find((tech) =>
      paramKeys.includes(normalizeTechnology(tech))
    );

    return match || "All Technologies";
  };

  useEffect(() => {
    filterPortfolio(selectedIndustry, selectedTechnology);
  }, [selectedIndustry, selectedTechnology]);

  useEffect(() => {
    const resolvedTechnology = resolveTechnologyFromParams(searchParams);

    if (resolvedTechnology !== selectedTechnology) {
      setSelectedTechnology(resolvedTechnology);
    }
  }, [searchParams, selectedTechnology]);

  useEffect(() => {
    const queryTechnology = searchParams.get("technology");

    if (queryTechnology) {
      const resolvedTechnology = resolveTechnologyFromQuery(queryTechnology);
      const normalized = normalizeTechnology(resolvedTechnology);

      if (resolvedTechnology !== "All Technologies") {
        navigate({ search: `?${normalized}` }, { replace: true });
      } else {
        navigate({ search: "" }, { replace: true });
      }
    }
  }, [navigate, searchParams]);

  const handleIndustryDropdownToggle = () => {
    setIsActiveIndustry(!isActiveIndustry);
    setIsActiveTechnology(false);
  };

  const handleTechnologyDropdownToggle = () => {
    setIsActiveTechnology(!isActiveTechnology);
    setIsActiveIndustry(false);
  };

  const handleIndustrySelection = (industry) => {
    setSelectedIndustry(industry);
    setIsActiveIndustry(false);
  };

  const handleTechnologySelection = (technology) => {
    setSelectedTechnology(technology);
    setIsActiveTechnology(false);

    if (technology === "All Technologies") {
      navigate({ search: "" }, { replace: true });
      return;
    }

    const normalized = normalizeTechnology(technology);
    navigate({ search: `?${normalized}` }, { replace: true });
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        industryRef.current &&
        !industryRef.current.contains(event.target) &&
        technologyRef.current &&
        !technologyRef.current.contains(event.target)
      ) {
        setIsActiveIndustry(false);
        setIsActiveTechnology(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const filterPortfolio = (industry, technology) => {
    setFiltering(true);

    let filtered = portfolioData;

    // Filter by industry
    if (industry !== "All Industries") {
      filtered = filtered.filter((item) => item.category === industry);
    }

    // Filter by technology
    if (technology !== "All Technologies") {
      filtered = filtered.filter(
        (item) =>
          item.technologies &&
          item.technologies.some(
            (tech) =>
              normalizeTechnology(tech.name) ===
              normalizeTechnology(technology),
          ),
      );
    }

    setTimeout(() => {
      setFilteredItems(filtered);
      setDisplayedItems(filtered.slice(0, itemsPerPage));
      setHasMore(filtered.length > itemsPerPage);
      setFiltering(false);
    }, 1000);
  };

  const loadMoreItems = () => {
    setLoading(true);

    setTimeout(() => {
      const currentLength = displayedItems.length;
      const moreItems = filteredItems.slice(
        currentLength,
        currentLength + itemsPerPage,
      );

      setDisplayedItems((prevItems) => [...prevItems, ...moreItems]);
      setHasMore(currentLength + moreItems.length < filteredItems.length);
      setLoading(false);
    }, 1000);
  };

  const handleNavigate = (title) => {
    navigate("/Portfolio/InnerPortfolio", { state: { title } });
  };

  return (
    <>
      <section className="second-portfolio-section">
        <Container>
          <div className="top-text-services">
            <h2>
              OUR <span> PORTFOLIO</span>
            </h2>
          </div>
          <div className="drop-down-row">
            <div></div>
            <div className="drop-down-select">
              <div className="select" ref={industryRef}>
                <div
                  className={`selectBtn ${isActiveIndustry ? "active" : ""}`}
                  onClick={handleIndustryDropdownToggle}
                >
                  {selectedIndustry}
                </div>
                <div
                  className={`selectDropdown ${
                    isActiveIndustry ? "toggle" : ""
                  }`}
                >
                  {industries.map((industry, index) => (
                    <div
                      key={index}
                      className="option"
                      onClick={() => handleIndustrySelection(industry)}
                    >
                      {industry}
                    </div>
                  ))}
                </div>
              </div>

              <div className="drop-down-select" ref={technologyRef}>
                <div className="select">
                  <div
                    className={`selectBtn ${
                      isActiveTechnology ? "active" : ""
                    }`}
                    onClick={handleTechnologyDropdownToggle}
                  >
                    {selectedTechnology}
                  </div>
                  <div
                    className={`selectDropdown ${
                      isActiveTechnology ? "toggle" : ""
                    }`}
                  >
                    {technologies.map((technology, index) => (
                      <div
                        key={index}
                        className="option"
                        onClick={() => handleTechnologySelection(technology)}
                      >
                        {technology}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {filtering ? (
            <div className="loader-container">
              <img src={loader} alt="Filtering..." className="loader" />
            </div>
          ) : (
            <InfiniteScroll
              dataLength={displayedItems.length}
              next={loadMoreItems}
              hasMore={hasMore}
              loader={
                <div className="loader-container">
                  {loading && (
                    <img src={loader} alt="Loading..." className="loader" />
                  )}
                </div>
              }
            >
              <div
                className="row our-portfolio-page-row"
                id="portfolio-container"
              >
                {displayedItems.length === 0 ? (
                  <div className="col-12">
                    <h2 className="not-found-text">No Portfolio Found</h2>
                  </div>
                ) : (
                  displayedItems.map((item, index) => (
                    <div
                      key={index}
                      className="col-xl-4 col-md-6 col-sm-12 our-portfolio-page-col-1"
                    >
                      <div
                        className="other-from-wo"
                        onClick={() => handleNavigate(item.title)}
                      >
                        <div className="inner-page-card-wrapper position-relative">
                          <div className="img-card">
                            <img
                              src={item.imgSrc}
                              className="w-100"
                              alt="main"
                            />
                          </div>
                          <div className="img-card-absolute position-absolute">
                            <img src={item.logoSrc} alt="peta" />
                          </div>
                          <h3>{item.title}</h3>
                          <p>{item.category}</p>
                          <p className="web-app">
                            {truncateText(item?.description)}
                          </p>
                        </div>
                      </div>
                    </div>
                  ))
                )}
              </div>
            </InfiniteScroll>
          )}
        </Container>
      </section>
    </>
  );
};

export default Second;
